import React, { Component } from 'react'
import StaticsProduce3D from "./StaticsProduce3D"
import StaticsProduce2D from "./StaticsProduce2D"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { ReactComponent as IconHead } from "../../../assets/icon/icon-head.svg"
import { statisticSKU2D, statisticSKU3D } from "../../../services/api/apiOrdersReport"
import PubSub from "pubsub-js"
import { getListSku } from "../../../services/api/apiSku"
import store from 'store'
import { Select } from 'antd'

class StaticsProducePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: {
                loading3D: false,
                loading2D: false
            },
            error: {
                error3D: '',
                error2D: ''
            },
            dataStatics: {
                data3D: [],
                data2D: []
            },
            sortData: {
                sort2D: {
                    sort: 'total',
                    desc: true
                },
                sort3D: {
                    sort: 'total',
                    desc: true
                }
            },
            loadingSku: false,
            errorListSku: '',
            listSkus: [],
            item_overtime: [],
            type: ['*'],
            skus: ['*'],
            is_cheap_product: '',
        }
    }

    _subscription = null
    _subscription2 = null

    componentDidMount() {
        this._fetchListSku()
        this._subscription = PubSub.subscribe('RELOAD_STATICS_3D', this._fetchProductionStatic3D)
        this._subscription2 = PubSub.subscribe('RELOAD_STATICS_2D', this._fetchProductionStatic2D)
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this._subscription)
        PubSub.unsubscribe(this._subscription2)
    }

    _onChangeListSku = (key, listSku) => {
        this.setState({
            [key]: listSku
        })
    }

    _sortArray = (data, key, desc) => {
        return data.sort((a, b) => {
            if (!desc) {
                return a[key] - b[key]
            } else {
                return b[key] - a[key]
            }
        })
    }

    _onChangeSort3D = (key, desc) => {
        const { dataStatics, sortData } = this.state
        const { data3D } = dataStatics

        if (data3D !== undefined && data3D.length > 0) {
            this.setState({
                sortData: {
                    ...sortData,
                    sort3D: {
                        sort: key,
                        desc: desc
                    }
                }
            }, () => {
                const { sort, desc: sortType } = this.state.sortData.sort3D
                const newData = this._sortArray(data3D, sort, sortType)

                this.setState({
                    dataStatics: {
                        ...dataStatics,
                        data3D: newData
                    }
                })
            })
        }
    }

    _onChangeSort2D = (key, desc) => {
        const { dataStatics, sortData } = this.state
        const { data2D } = dataStatics

        if (data2D !== undefined && data2D.length > 0) {
            this.setState({
                sortData: {
                    ...sortData,
                    sort2D: {
                        sort: key,
                        desc: desc
                    }
                }
            }, () => {
                const { sort, desc: sortType } = this.state.sortData.sort2D
                const newData = this._sortArray(data2D, sort, sortType)

                this.setState({
                    dataStatics: {
                        ...dataStatics,
                        data2D: newData
                    }
                })
            })
        }
    }

    _fetchProductionStatic3D = async () => {
        this.setState({
            loading: {
                ...this.state.loading,
                loading3D: true
            },
            error: {
                ...this.state.error,
                error3D: ''
            },
            dataStatics: {
                ...this.state.dataStatics,
                data3D: []
            }
        })

        try {
            const { type, item_overtime, is_cheap_product } = this.state
            const payload = {
                type: type,
            }
            if (item_overtime.length) { payload.item_overtime = item_overtime }
            if (!!is_cheap_product && is_cheap_product !== 'all') payload.is_cheap_product = is_cheap_product

            const { data: response } = await statisticSKU3D(payload)

            const { success, data, message } = response

            if (!success) {
                return this.setState({
                    loading: {
                        ...this.state.loading,
                        loading3D: false
                    },
                    error: {
                        ...this.state.error,
                        error3D: message
                    }
                })
            }

            const newData = []

            Object.keys(data).forEach(key => {
                newData.push({ sku: key, ...data[key] })
            })

            this.setState({
                loading: {
                    ...this.state.loading,
                    loading3D: false
                },
                error: {
                    ...this.state.error,
                    error3D: ''
                },
                dataStatics: {
                    ...this.state.dataStatics,
                    data3D: newData
                }
            })
        } catch (e) {
            this.setState({
                loading: {
                    ...this.state.loading,
                    loading3D: false
                },
                error: {
                    ...this.state.error,
                    error3D: e.message
                }
            })
        }
    }

    _fetchProductionStatic2D = async () => {
        this.setState({
            loading: {
                ...this.state.loading,
                loading2D: true
            },
            error: {
                ...this.state.error,
                error2D: ''
            },
            dataStatics: {
                ...this.state.dataStatics,
                data2D: []
            }
        })

        try {
            const { skus, item_overtime, is_cheap_product } = this.state
            const payload = {
                skus: skus,
            }
            if (item_overtime.length) { payload.item_overtime = item_overtime }
            if (!!is_cheap_product && is_cheap_product !== 'all') payload.is_cheap_product = is_cheap_product
            const { data: response } = await statisticSKU2D(payload)

            const { success, data, message } = response

            if (!success) {
                return this.setState({
                    loading: {
                        ...this.state.loading,
                        loading2D: false
                    },
                    error: {
                        ...this.state.error,
                        error2D: message
                    }
                })
            }

            const newData = []

            Object.keys(data).forEach(key => {
                newData.push({ sku: key, ...data[key] })
            })

            this.setState({
                loading: {
                    ...this.state.loading,
                    loading2D: false
                },
                error: {
                    ...this.state.error,
                    error2D: ''
                },
                dataStatics: {
                    ...this.state.dataStatics,
                    data2D: newData
                }
            })
        } catch (e) {
            this.setState({
                loading: {
                    ...this.state.loading,
                    loading2D: false
                },
                error: {
                    ...this.state.error,
                    error2D: ''
                }
            })
        }
    }

    _fetchListSku = async () => {
        this.setState({
            loadingSku: true,
            errorListSku: '',
        })

        try {
            const payload = {
                limit: 1000,
                page: 1,
                sort: "sku",
                skip_meta: false,
                select: ['procedure', 'sku'],
                is_active: true
            }

            const { 'data': respons } = await getListSku(payload)

            const { success, data, message } = respons

            if (!success) {
                return this.setState({
                    loadingSku: false,
                    errorListSku: message,
                })
            }

            const { items } = data

            const SkuID = items.map(item => {
                return {
                    sku: item.sku,
                    procedure: item.procedure
                }
            })

            if (store.get('listSkus') && store.get('listSkus').length > 0) {
                const oldSkus = store.get('listSkus')
                const oldSkusName = oldSkus.map(itemName => itemName.sku)
                const skuNew = SkuID.filter(itemSku => !oldSkusName.includes(itemSku.sku))
                if (skuNew.length > 0) {
                    const new3D = skuNew.filter(item3D => item3D.procedure === '3D')
                    const new2D = skuNew.filter(item2D => item2D.procedure === '2D')

                    const selected3D = store.get('listSkuStatics') ? store.get('listSkuStatics').sku3D : []
                    const selected2D = store.get('listSkuStatics') ? store.get('listSkuStatics').sku2D : []

                    const objSkuStatics = {
                        sku3D: new3D.length > 0 ? selected3D.concat(new3D.map(item3D => item3D.sku)) : selected3D,
                        sku2D: new2D.length > 0 ? selected2D.concat(new2D.map(item2D => item2D.sku)) : selected2D,
                    }
                    store.set('listSkuStatics', objSkuStatics)
                }
            }

            store.set('listSkus', SkuID)
            const listSku = store.get('listSkuStatics')

            this.setState({
                listSkus: items,
                loadingSku: false,
                skus: !!listSku && !!listSku.sku2D ? [...listSku.sku2D] : this.state.skus,
                type: !!listSku && !!listSku.sku3D ? [...listSku.sku3D] : this.state.type
            }, async () => {
                await this._fetchProductionStatic3D()
                await this._fetchProductionStatic2D()
            })
        } catch (e) {
            this.setState({
                loadingSku: false,
                errorListSku: e.message,
            })
        }
    }

    _calculatorItemWidth = () => {
        const { listSkus } = this.state

        let width3D = 0, width2D = 0

        for (let i = 0; i < listSkus.length; i++) {
            if (listSkus[i].procedure === '3D') {
                if (listSkus[i].sku.length > width3D) width3D = parseInt(listSkus[i].sku.length)
            } else {
                if (listSkus[i].sku.length > width2D) width2D = parseInt(listSkus[i].sku.length)
            }
        }

        return { width2D: parseInt(width2D) * 10 + 30, width3D: parseInt(width3D) * 10 + 30 }
    }

    handleToggleOvertime = (e) => {
        this.setState({
            reportType: e.target.value === 'yes' ? 'overtime' : ''
        }, () => {
            this._fetchProductionStatic2D()
            this._fetchProductionStatic3D()
        })
    }

    reload = () => {
        this.setState({
            loading: {
                ...this.state.loading,
                loading2D: true,
                loading3D: true,
            }
        }, () => {
            this._fetchProductionStatic2D()
            this._fetchProductionStatic3D()
        })
    }

    getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if (i !== 0) {
                const Option = {
                    name: i,
                    value: i,
                }
                Options.push(Option)
            }
        }
        return Options
    }

    handleOverTime = (value) => {
        this.setState({ item_overtime: value })
        this.reload()
    }

    handleCheapProduct = (value) => {
        this.setState({ is_cheap_product: value })
        this.reload()
    }

    render() {
        const { dataStatics, sortData, loading, error, type, skus, loadingSku, errorListSku, reportType, item_overtime, is_cheap_product } = this.state
        const { data3D, data2D } = dataStatics
        const { sort3D, sort2D } = sortData
        const { loading2D, loading3D } = loading
        const { error2D, error3D } = error
        const widthItem = this._calculatorItemWidth()
        const Option = Select.Option
        const OverTimeOption = this.getOptionOverTime(-6, 6)
        const cheapProductsOption = [
            { name: 'All', value: 'all' },
            { name: 'Giá rẻ', value: 'true' },
            { name: 'Thường', value: 'false' },
        ]

        return (
            <Row className='text-center'>
                <Col md={12} className="Left">
                    <div className='StaticsProduce'>
                        <Card>
                            <CardHeader className="d-flex flex-wrap align-items-center justify-content-between bg-warning text-dark header-elements-inline">
                                <h2 className="card-title d-flex align-items-center mr-3">
                                    <IconHead />
                                    Thống kê sản xuất
                                </h2>
                                {loadingSku && <span className="ml-2 pt-1">Loading...</span>}
                                {errorListSku && <span className="ml-2 pt-1 text-danger">{errorListSku}</span>}
                                <div className="filter d-flex flex-wrap align-items-center">
                                    <Select
                                        showArrow={true}
                                        mode='multiple'
                                        className='mr-0 mr-3 mb-2 text-left'
                                        allowClear
                                        style={{ minWidth: '190px', maxWidth: '450px' }}
                                        placeholder='Ngày quá hạn sản xuất'
                                        onChange={(value) => this.handleOverTime(value)}
                                        defaultValue={item_overtime}
                                    >
                                        {
                                            OverTimeOption.map((item, index) =>
                                                <Option key={index} value={item.value}>
                                                    {item.name}
                                                </Option>
                                            )
                                        }
                                    </Select>
                                    <Select
                                        showArrow={true}
                                        className='mr-0 mb-2 text-left'
                                        allowClear
                                        style={{ minWidth: '190px', maxWidth: '450px' }}
                                        placeholder='Sản phẩm giá rẻ'
                                        onChange={(value) => this.handleCheapProduct(value)}
                                        defaultValue={is_cheap_product || []}
                                    >
                                        {
                                            cheapProductsOption.map((item, index) =>
                                                <Option key={index} value={item.value}>
                                                    {item.name}
                                                </Option>
                                            )
                                        }
                                    </Select>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <StaticsProduce3D
                                    showButtonSelect={!loading2D && !loading3D && !loadingSku}
                                    loading={loading3D}
                                    error={error3D}
                                    data3D={data3D}
                                    sort={sort3D.sort}
                                    desc={sort3D.desc}
                                    widthItem={widthItem.width3D}
                                    onChangeSort={this._onChangeSort3D}
                                    onChangeListSku={this._onChangeListSku}
                                    type={type}
                                />
                                <StaticsProduce2D
                                    showButtonSelect={!loading2D && !loading3D && !loadingSku}
                                    loading={loading2D}
                                    error={error2D}
                                    data2D={data2D}
                                    sort={sort2D.sort}
                                    desc={sort2D.desc}
                                    widthItem={widthItem.width2D}
                                    onChangeSort={this._onChangeSort2D}
                                    onChangeListSku={this._onChangeListSku}
                                    skus={skus}
                                />
                            </CardBody>
                        </Card>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default StaticsProducePage
